import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { RouteDrawer } from "#/components/route-drawer";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/students/$id/social-results/drawer",
)({
  component: SocialResultsDrawer,
});

function SocialResultsDrawer() {
  const navigate = useNavigate();

  return (
    <RouteDrawer
      onClose={() => {
        void navigate({
          from: Route.fullPath,
          to: "/$locale/{-$schoolyear}/$school/students/$id/social-results",
          params: (prev) => prev,
          search: (prev) => prev,
          replace: true,
          resetScroll: false,
          viewTransition: true,
        });
      }}
    >
      <Outlet />
    </RouteDrawer>
  );
}
